module.exports = __webpack_public_path__ + "img/zoosk.27a4755.png";